import Dexie, {Table} from 'dexie';

export interface StoredData {
  id: string;
  data: string;
  insertedAt?: number;
}

export const STICKER_UPLOAD_INDEXED_DB_STORE_NAME = 'sticker-upload';
export const GALLERY_PHOTO_PREVIEW_INDEXED_DB_STORE_NAME = 'gallery-photo-preview';
export const GALLERY_PHOTO_PREVIEW_MEDIA_ID = 'uploaded-img';

class EviteDB extends Dexie {
  public [STICKER_UPLOAD_INDEXED_DB_STORE_NAME]!: Table<StoredData, string>;

  public [GALLERY_PHOTO_PREVIEW_INDEXED_DB_STORE_NAME]!: Table<StoredData, string>;

  constructor() {
    super('evite-db');
    this.version(1).stores({
      [STICKER_UPLOAD_INDEXED_DB_STORE_NAME]: 'id, insertedAt',
      [GALLERY_PHOTO_PREVIEW_INDEXED_DB_STORE_NAME]: 'id, insertedAt',
    });
  }
}

export const eviteDB = new EviteDB();
